/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GetReservationCapacities200ResponseOneOf } from './GetReservationCapacities200ResponseOneOf';
import {
    instanceOfGetReservationCapacities200ResponseOneOf,
    GetReservationCapacities200ResponseOneOfFromJSON,
    GetReservationCapacities200ResponseOneOfFromJSONTyped,
    GetReservationCapacities200ResponseOneOfToJSON,
} from './GetReservationCapacities200ResponseOneOf';
import type { GetReservationCapacities200ResponseOneOf1 } from './GetReservationCapacities200ResponseOneOf1';
import {
    instanceOfGetReservationCapacities200ResponseOneOf1,
    GetReservationCapacities200ResponseOneOf1FromJSON,
    GetReservationCapacities200ResponseOneOf1FromJSONTyped,
    GetReservationCapacities200ResponseOneOf1ToJSON,
} from './GetReservationCapacities200ResponseOneOf1';

/**
 * @type GetReservationCapacities200Response
 * 
 * @export
 */
export type GetReservationCapacities200Response = GetReservationCapacities200ResponseOneOf | GetReservationCapacities200ResponseOneOf1;

export function GetReservationCapacities200ResponseFromJSON(json: any): GetReservationCapacities200Response {
    return GetReservationCapacities200ResponseFromJSONTyped(json, false);
}

export function GetReservationCapacities200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationCapacities200Response {
    if (json == null) {
        return json;
    }
    if (instanceOfGetReservationCapacities200ResponseOneOf(json)) {
        return GetReservationCapacities200ResponseOneOfFromJSONTyped(json, true);
    }
    if (instanceOfGetReservationCapacities200ResponseOneOf1(json)) {
        return GetReservationCapacities200ResponseOneOf1FromJSONTyped(json, true);
    }

    return {} as any;
}

export function GetReservationCapacities200ResponseToJSON(json: any): any {
    return GetReservationCapacities200ResponseToJSONTyped(json, false);
}

export function GetReservationCapacities200ResponseToJSONTyped(value?: GetReservationCapacities200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfGetReservationCapacities200ResponseOneOf(value)) {
        return GetReservationCapacities200ResponseOneOfToJSON(value as GetReservationCapacities200ResponseOneOf);
    }
    if (instanceOfGetReservationCapacities200ResponseOneOf1(value)) {
        return GetReservationCapacities200ResponseOneOf1ToJSON(value as GetReservationCapacities200ResponseOneOf1);
    }

    return {};
}

